import { Box, Paper, Stack, Typography } from "@mui/material";

interface Props {
  data: number[][]; // 7 rows × 10 cols
}

const DAYS = [
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
  "Dimanche",
];
const HOURS = [
  "9h",
  "10h",
  "11h",
  "12h",
  "13h",
  "14h",
  "15h",
  "16h",
  "17h",
  "18h",
];

const cellColor = (value: number, max: number): string => {
  if (max === 0 || value === 0) return "#f5f5f5";
  const ratio = value / max;
  if (ratio < 0.25) return "#c8e6c9";
  if (ratio < 0.5) return "#81c784";
  if (ratio < 0.75) return "#4caf50";
  return "#2e7d32";
};

export const VisitsHeatmap = ({ data }: Props) => {
  const max = Math.max(0, ...data.flat());
  return (
    <Paper sx={{ p: 2 }} elevation={1}>
      <Typography variant="caption" color="text.secondary">
        Heatmap d'affluence des visites (Jour × Heure)
      </Typography>
      <Box
        sx={{
          mt: 2,
          display: "grid",
          gridTemplateColumns: `90px repeat(${HOURS.length}, 1fr)`,
          gap: 0.5,
          alignItems: "center",
        }}
      >
        <Box />
        {HOURS.map((h) => (
          <Typography
            key={h}
            variant="caption"
            color="text.secondary"
            textAlign="center"
          >
            {h}
          </Typography>
        ))}
        {DAYS.map((day, dow) => (
          <>
            <Typography key={`label-${day}`} variant="body2" fontWeight="bold">
              {day}
            </Typography>
            {HOURS.map((_, h) => {
              const v = data[dow]?.[h] ?? 0;
              return (
                <Box
                  key={`${day}-${h}`}
                  sx={{
                    height: 28,
                    bgcolor: cellColor(v, max),
                    borderRadius: 0.5,
                  }}
                />
              );
            })}
          </>
        ))}
      </Box>
      <Stack direction="row" gap={2} mt={2} alignItems="center">
        <Typography variant="caption" color="text.secondary">
          Affluence:
        </Typography>
        {[
          { label: "0", color: "#f5f5f5" },
          { label: "Faible", color: "#c8e6c9" },
          { label: "Modérée", color: "#81c784" },
          { label: "Forte", color: "#4caf50" },
          { label: "Très forte", color: "#2e7d32" },
        ].map((l) => (
          <Stack key={l.label} direction="row" gap={0.5} alignItems="center">
            <Box
              sx={{
                width: 14,
                height: 14,
                bgcolor: l.color,
                borderRadius: 0.5,
              }}
            />
            <Typography variant="caption">{l.label}</Typography>
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
};
